/* eslint-disable */

export const BRANCHNAME = process.env.BRANCHNAME || 'local';
export const IMAGE_ROOT = `${process.env.BRANCH_PREFIX}/images` || '/images';
export const ENV = process.env.NODE_ENV || 'local';
export const API_PATH = process.env.API_PATH || 'https://pam-api-dev.reppublika.com';
export const LANG_CODE = process.env.LANG_CODE || 'en';

export const PANEL = process.env.VUE_APP_PANEL || 'talk';
